export enum EDisrupterPlacement {
  // Page Lead
  LEAD,
  // Recommendation card
  CARD,
  // Theme recs slider
  SLIDER,
}
